export interface SubscriptionModule {
  id: number;
  name: string;
  abbreviation: string;
}

export interface LookupTableItem {
  id: string;
  name: string;
  description?: string;
}

export enum LookupTableItemKeys {
  ID = "id",
  NAME = "name",
}

export interface NestedLookupTableItem extends LookupTableItem {
  // Only single level children are expected
  children?: LookupTableItem[];
}

export enum NestedLookupTableItemKeys {
  ID = "id",
  NAME = "name",
  CHILDREN = "children",
}

// Commented out lines are included in response, but not yet utilized in front-end app
export enum LookupTablesKeys {
  // Tables that are used in same format returned from backend
  // TODO: not all of these are utilized in FE, compare with API and clean up both
  EDITORIAL_GROUPS = "editorialGroups",
  STATES = "states",
  COUNTRIES = "countries",
  PRIMARY_PROFILE_TYPES = "primaryProfileTypes",
  SECONDARY_PROFILE_TYPES = "secondaryProfileTypes",
  // POSITION_STATUSES = "positionStatuses",
  GENDERS = "genders",
  POLITICAL_PARTIES = "politicalParties",
  MARITAL_STATUSES = "maritalStatuses",
  ETHNICITIES = "ethnicities",
  RELIGIONS = "religions",
  // INDUSTRIES = "industries",
  DEGREES = "degrees",
  // DISTRICTS = "districts",
  // KEY_POLICY_AREAS = "keyPolicyAreas",

  // Flattened nested lookup tables, some lists are post-processed for frontend indexing purposes
  // TODO: some of these should not be labeled as _FLAT, move to above list
  PROFILE_TYPES_FLAT = "profileTypesFlat",
  KEY_POLICY_AREAS_FLAT = "keyPolicyAreasFlat",
  INDUSTRIES_FLAT = "industriesFlat",
  COMMITTEES_FLAT = "committeesFlat",
  CAUCUSES_FLAT = "caucusesFlat",
  AGENCIES_FLAT = "agenciesFlat",
  SPECIAL_INTEREST_GROUPS_FLAT = "specialInterestGroupsFlat",

  // Birthdate tables
  BIRTH_YEAR_OPTIONS = "birthYearOptions",
  BIRTH_YEAR_OPERATOR = "birthYearOperator",
  AGE_OPTIONS = "ageOptions",
  AGE_OPERATOR = "ageOperator",

  // Special Interest Groups tables
  SIG_OPERATOR = "sigOperator",
  SIG_RATING_OPTIONS = "sigRatingOptions",
}

export interface LookupTables {
  subscriptionModules: SubscriptionModule[];
  editorialGroups: LookupTableItem[];
  states: LookupTableItem[];
  countries: LookupTableItem[];
  primaryProfileTypes: LookupTableItem[];
  secondaryProfileTypes: LookupTableItem[];
  positionStatuses: LookupTableItem[];
  genders: LookupTableItem[];
  politicalParties: LookupTableItem[];
  maritalStatuses: LookupTableItem[];
  ethnicities: LookupTableItem[];
  religions: LookupTableItem[];
  industries: LookupTableItem[];
  degrees: LookupTableItem[];
  districts: LookupTableItem[];
  profileTypesFlat: LookupTableItem[];
  keyPolicyAreasFlat: LookupTableItem[];
  industriesFlat: LookupTableItem[];
  committeesFlat: LookupTableItem[];
  caucusesFlat: LookupTableItem[];
  agenciesFlat: LookupTableItem[];
  specialInterestGroupsFlat: LookupTableItem[];

  // Computed
  birthYearOptions: LookupTableItem[];
  ageOptions: LookupTableItem[];
  birthYearOperator: LookupTableItem[];
  ageOperator: LookupTableItem[];
  sigOperator: LookupTableItem[];
  sigRatingOptions: LookupTableItem[];
}

export enum NestedLookupTablesKeys {
  PROFILE_TYPES = "profileTypes",
  KEY_POLICY_AREAS = "keyPolicyAreas",
  INDUSTRIES = "industries",
  COMMITTEES = "committees",
  CAUCUSES = "caucuses",
  AGENCIES = "agencies",
  SPECIAL_INTEREST_GROUPS = "specialInterestGroups",
}

export interface NestedLookupTables {
  profileTypes: NestedLookupTableItem[];
  keyPolicyAreas: NestedLookupTableItem[];
  industries: NestedLookupTableItem[];
  committees: NestedLookupTableItem[];
  caucuses: NestedLookupTableItem[];
  agencies: NestedLookupTableItem[];
  specialInterestGroups: NestedLookupTableItem[];
}
